import { useEffect, useState } from 'react';
import {
  type Control,
  type FieldValues,
  useFormContext,
  useWatch,
} from 'react-hook-form';
import { useField } from '../../field/useField.tsx';

interface UseWatchFieldProps {
  name: string;
  defaultValue?: unknown;
  disabled?: boolean;
  control?: Control<FieldValues>;
  exact?: boolean;
}

/**
 * Versione modificata di `useWatch` che tiene conto della visibilità del campo.
 */
export function useWatchField(props: UseWatchFieldProps) {
  const [value, setValue] = useState(props.defaultValue);
  const { getValues: getFormValues } = useFormContext();
  const { visible } = useField(props.name);

  // 1. `useWatch` normale, ogni volta che il valore cambia
  // aggiorniamo il valore in memoizzato in `value`
  const watchedValue = useWatch(props);
  useEffect(() => {
    setValue(watchedValue);
  }, [watchedValue]);

  // 2. Quando cambia la visibilità, `useWatch` non viene chiamato
  // quindi dobbiamo aggiornare il valore manualmente
  useEffect(() => {
    const actualValue = getFormValues(props.name);
    setValue(actualValue);
  }, [visible, getFormValues, props.name]);

  return value;
}
